export function snakeToLowerCamel(subject: string): string {
  const replacer = function (stringToReplace: string): string {
    return stringToReplace.toUpperCase().replace("_", "");
  };

  return subject.toLowerCase().replace(/([_][a-z0-9])/g, replacer);
}
